export default __webpack_public_path__ + "static/media/send.ef29d896.webp";